import React from "react";
import { getDefaultUserAvatar } from "winslow-core";
import "./ThreadInfo.css";
import { useValidatedImageUrl } from "../../hooks/useValidatedImageUrl";

type ThreadInfoProps = {
  avatar?: string;
  label: string;
  className?: string;
};

export const ThreadInfo = ({
  avatar,
  label,
  className = "",
}: ThreadInfoProps) => {
  const fallbackAvatar = getDefaultUserAvatar(label);
  const { validatedUrl, isValidating } = useValidatedImageUrl(
    avatar || "",
    fallbackAvatar
  );

  return (
    <>
      {label === "" ? null : (
        <div className={`agent-chat-thread-info ${className}`}>
          {label && label !== "Removed Context" && (
            <div className="agent-chat-thread-info-avatar">
              {isValidating ? (
                <div className="avatar-loading">...</div>
              ) : (
                <img src={validatedUrl} alt="Thread Avatar" />
              )}
            </div>
          )}
          <div className="agent-chat-thread-info-name">{label}</div>
        </div>
      )}
    </>
  );
};
